import { TableHead, TableHeader, TableRow } from '@/components/ui';

export const DataTableHeaderPaymentInfo = () => (
  <TableHeader>
    <TableRow>
      <TableHead colSpan={7} />
      <TableHead colSpan={4} className='pe-0'>
        Informations de paiement
      </TableHead>
    </TableRow>
  </TableHeader>
);

export default DataTableHeaderPaymentInfo;
